<div class="flex flex-col gap-4 p-4 border border-gray-200 rounded-lg bg-white h-[208px]">
  <!-- Header: Status-Icon + Name + Origin-Tag + Menu -->
  <div class="flex flex-row items-center gap-2">
    <fa-icon
      [icon]="isActive ? faCircleCheck : faCircleExclamation"
      [class]="isActive ? 'text-green' : 'text-yellow'"
      [tooltip]="statusTooltip"
      class="text-svg-16 shrink-0"
      tooltipDirection="top"></fa-icon>
    <span class="text-sm font-medium text-gray-900 truncate flex-1">{{ check.name }}</span>
    @if (newCatalogVersion !== null) {
      <span [tooltip]="newVersionTooltip" class="shrink-0" tooltipDirection="top">
        <bic-badge bgClass="bg-green-100" textClass="text-gray-700">Neue Version verfügbar</bic-badge>
      </span>
    }
    @if (catalogBadgeLabel) {
      <span [tooltip]="catalogBadgeTooltip" class="shrink-0" tooltipDirection="top">
        <bic-badge [bgClass]="catalogSubmission?.status === 'REJECTED' ? 'bg-red-100' : catalogSubmission?.status === 'INSTALLED' ? 'bg-green-100' : 'bg-yellow-100'"
                   [textClass]="catalogSubmission?.status === 'REJECTED' ? 'text-red' : catalogSubmission?.status === 'INSTALLED' ? 'text-green-900' : 'text-yellow-900'">{{ catalogBadgeLabel }}</bic-badge>
      </span>
    }
    <bic-badge [bgClass]="originBadge.bgClass" [textClass]="originBadge.textClass">
      {{ originBadge.label }}
    </bic-badge>
    <!-- Bei einer Freigabe ersetzt das Schloss-Icon das Punktemenü: Duplizieren ist die einzige
         erlaubte Aktion und über den Button unten ohnehin erreichbar. -->
    @if (isShared) {
      <fa-icon [icon]="faLock"
               [tooltip]="lockTooltip"
               class="text-svg-14 text-gray-400 shrink-0"
               tooltipDirection="top"></fa-icon>
    } @else if (!check.readOnly) {
      <button (click)="$event.stopPropagation()"
              [bicDropdownTrigger]="cardMenu"
              class="flex items-center justify-center w-4 h-4 text-gray-500 hover:text-gray-700">
        <fa-icon [icon]="faEllipsisVertical" class="text-xs"></fa-icon>
      </button>
      <bic-dropdown #cardMenu [dropdownPlacement]="'bottom-end'">
        @if (archived) {
          @if (canManage) {
            <bic-dropdown-element (click)="onAction('restore')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faArrowRotateRight" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Wiederherstellen</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faArrowRotateRight" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Wiederherstellen</span>
              </div>
            </bic-dropdown-element>
          }
        } @else {
          @if (canManage) {
            <bic-dropdown-element (click)="onAction('duplicate')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faCopy" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Duplizieren</span>
              </div>
            </bic-dropdown-element>
            <bic-dropdown-element (click)="onAction(pinned ? 'unpin' : 'pin')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="pinned ? faThumbtackSlash : faThumbtack" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>{{ pinned ? 'Lösen' : 'Anheften' }}</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faCopy" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Duplizieren</span>
              </div>
            </bic-dropdown-element>
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="pinned ? faThumbtackSlash : faThumbtack" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>{{ pinned ? 'Lösen' : 'Anheften' }}</span>
              </div>
            </bic-dropdown-element>
          }
          <!-- Zeitplan: braucht nur das Ausführen-Recht, nicht „myCheck verwalten“. -->
          @if (canExecute) {
            <bic-dropdown-element (click)="onAction('schedule')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faCalendarClock" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Zeitplan</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noScheduleTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faCalendarClock" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Zeitplan</span>
              </div>
            </bic-dropdown-element>
          }
          <!-- Teilen mit anderen Projekten der Organisation. Bewusst NICHT die Adminfunktion:
               die steht unten in der eigenen Administrations-Sektion. -->
          @if (isLinkedIn) {
            @if (canManage) {
              <bic-dropdown-element (click)="onAction('unshare-here')">
                <div class="flex flex-row items-center gap-2 text-sm text-red">
                  <fa-icon [icon]="faLinkSlash" class="text-sm w-4"></fa-icon>
                  <span>Aus diesem Projekt entfernen</span>
                </div>
              </bic-dropdown-element>
            } @else {
              <bic-dropdown-element (click)="$event.stopPropagation()">
                <div [tooltip]="noManageTooltip"
                     class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                     tooltipDirection="top">
                  <fa-icon [icon]="faLinkSlash" class="text-sm text-gray-400 w-4"></fa-icon>
                  <span>Aus diesem Projekt entfernen</span>
                </div>
              </bic-dropdown-element>
            }
          } @else if (canShare) {
            <bic-dropdown-element (click)="onAction('share')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faPaperPlaneTop" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Teilen</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noManageTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faPaperPlaneTop" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Teilen</span>
              </div>
            </bic-dropdown-element>
          }
          @if (canTransferOwnership) {
            <bic-dropdown-element (click)="onAction('transfer-ownership')">
              <div class="flex flex-row items-center gap-2 text-sm text-gray-900">
                <fa-icon [icon]="faUserPen" class="text-sm text-gray-700 w-4"></fa-icon>
                <span>Eigentümer ändern</span>
              </div>
            </bic-dropdown-element>
          }
          <!-- Bei einem geteilten Prüflauf öffnet „Archivieren" die Wahl zwischen Besitz übergeben
               und überall entfernen – die Übersicht entscheidet anhand von sharedProjects. -->
          @if (isLinkedIn) {
            <!-- Archivieren gibt es nur im Eigentümerprojekt; hier ersetzt „Aus diesem Projekt
                 entfernen" den Eintrag. -->
          } @else if (canDelete) {
            <bic-dropdown-element (click)="onAction('archive')">
              <div class="flex flex-row items-center gap-2 text-sm text-red">
                <fa-icon [icon]="faBoxArchive" class="text-sm w-4"></fa-icon>
                <span>Archivieren</span>
              </div>
            </bic-dropdown-element>
          } @else {
            <bic-dropdown-element (click)="$event.stopPropagation()">
              <div [tooltip]="noDeleteTooltip"
                   class="flex flex-row items-center gap-2 text-sm text-gray-400 cursor-not-allowed"
                   tooltipDirection="top">
                <fa-icon [icon]="faBoxArchive" class="text-sm text-gray-400 w-4"></fa-icon>
                <span>Archivieren</span>
              </div>
            </bic-dropdown-element>
          }

          <!-- Nur für Plattform-Admins sichtbar und nur, wenn die Stage das Einreichen in den
               Katalog erlaubt. -->
          @if (canSubmitToCatalog) {
            <bic-dropdown-element (click)="onAction('provide-globally')">
              <div class="flex flex-row items-center gap-2 text-sm text-red">
                <fa-icon [icon]="faShieldCheck" class="text-sm w-4"></fa-icon>
                <span>Zentral bereitstellen</span>
              </div>
            </bic-dropdown-element>
          }
        }
      </bic-dropdown>
    }
  </div>

  <!-- Description; bei einem geteilten myCheck teilt sie sich die Höhe mit der Projektliste. -->
  @if (isSharedWithProjects) {
    <div class="flex flex-1 flex-col gap-1 min-h-0">
      <p class="text-sm text-gray-900 line-clamp-1">{{ description }}</p>
      <div [tooltip]="'Geteilt mit: ' + sharedProjectsLabel"
           class="flex flex-row items-center gap-1.5 text-xs text-gray-500 min-w-0"
           tooltipDirection="top">
        <fa-icon [icon]="faShareNodes" class="shrink-0"></fa-icon>
        <span class="truncate">{{ sharedProjectsLabel }}</span>
      </div>
    </div>
  } @else {
    <p class="text-sm text-gray-900 flex-1 line-clamp-2">{{ description }}</p>
  }

  <div class="flex flex-row items-center justify-between gap-3">
    <div class="flex flex-row items-center gap-1 text-sm text-gray-900">
      <span class="font-medium">{{ check.ruleCount }}</span>
      <span>{{ check.ruleCount === 1 ? 'myCheck' : 'myChecks' }}</span>
    </div>
    @if (scheduleLabel) {
      <div [tooltip]="scheduleTooltip"
           class="flex flex-row items-center gap-1.5 text-sm min-w-0"
           tooltipDirection="top">
        <fa-icon [class]="schedule?.status === 'PAUSED' ? 'text-yellow-900' : 'text-gray-500'" [icon]="faCalendarClock"
                 class="text-sm shrink-0"></fa-icon>
        <span [class]="schedule?.status === 'PAUSED' ? 'text-yellow-900' : 'text-gray-900'">{{ scheduleLabel }}</span>
      </div>
    }
    @if (lastChangedAt) {
      <div [tooltip]="'Zuletzt geändert am ' + (lastChangedAt | date:'dd.MM.yyyy, HH:mm') + ' Uhr'"
           class="flex flex-row items-center gap-1.5 text-sm text-gray-900 shrink-0"
           tooltipDirection="top">
        <fa-icon [icon]="faClock" class="text-sm text-gray-500"></fa-icon>
        <span>{{ lastChangedAt | date:'dd.MM.yyyy' }}</span>
      </div>
    }
  </div>

  <!-- Action buttons -->
  <div class="flex flex-row gap-4">
    @if (archived) {
      @if (canManage) {
        <bic-button (onClick)="onAction('restore')" buttonType="white" class="flex-1 [&>button]:w-full">
          <fa-icon [icon]="faArrowRotateRight" iconLeft></fa-icon>
          Wiederherstellen
        </bic-button>
      } @else {
        <span [tooltip]="noManageTooltip" class="flex-1" tooltipDirection="top">
          <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
            <fa-icon [icon]="faArrowRotateRight" iconLeft></fa-icon>
            Wiederherstellen
          </bic-button>
        </span>
      }
    } @else if (isShared || isLinkedIn) {
      <!-- Zentral bereitgestellt oder aus einem anderen Projekt geteilt: Ausführen ist erlaubt (läuft
           im eigenen Projekt, mit eigenen Dateien und Credits), Duplizieren zum Anpassen. Kein
           Öffnen – die Definition gehört dem Adminbereich bzw. dem Eigentümerprojekt. -->
      @if (!isActive || !canExecute) {
        <span
          [tooltip]="!canExecute ? 'Sie haben nicht die erforderlichen Berechtigungen, um den Check auszuführen.' : 'Dieser Check wurde noch nicht fertiggestellt.'"
          class="flex-1"
          tooltipDirection="top">
          <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
            <fa-icon [icon]="faPlay" iconLeft></fa-icon>
            Ausführen
          </bic-button>
        </span>
      } @else {
        <bic-button (onClick)="onAction('execute')" buttonType="white" class="flex-1 [&>button]:w-full">
          <fa-icon [icon]="faPlay" iconLeft></fa-icon>
          Ausführen
        </bic-button>
      }
      @if (canDuplicate) {
        <bic-button (onClick)="onAction('duplicate')" buttonType="white" class="flex-1 [&>button]:w-full">
          <fa-icon [icon]="faCopy" iconLeft></fa-icon>
          Duplizieren
        </bic-button>
      } @else {
        <span [tooltip]="noManageTooltip" class="flex-1" tooltipDirection="top">
          <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
            <fa-icon [icon]="faCopy" iconLeft></fa-icon>
            Duplizieren
          </bic-button>
        </span>
      }
    } @else {
      @if (!isActive || !canExecute) {
        <span [tooltip]="!canExecute ? 'Sie haben nicht die erforderlichen Berechtigungen, um den Check auszuführen.' : 'Dieser Check wurde noch nicht fertiggestellt.'"
              class="flex-1"
              tooltipDirection="top">
          <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
            <fa-icon [icon]="faPlay" iconLeft></fa-icon>
            Ausführen
          </bic-button>
        </span>
      } @else {
        <bic-button (onClick)="onAction('execute')" buttonType="white" class="flex-1 [&>button]:w-full">
          <fa-icon [icon]="faPlay" iconLeft></fa-icon>
          Ausführen
        </bic-button>
      }
      @if (!check.readOnly) {
        @if (canManage) {
          <bic-button (onClick)="onAction('open')" buttonType="white" class="flex-1 [&>button]:w-full">
            <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
            Öffnen
          </bic-button>
        } @else {
          <span [tooltip]="noManageTooltip" class="flex-1" tooltipDirection="top">
            <bic-button [disabled]="true" buttonType="white" class="[&>button]:w-full">
              <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
              Öffnen
            </bic-button>
          </span>
        }
      }
    }
  </div>
</div>
